import request from "@/utils/request"; // 添加

export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/activeManage/ticketInsert",
    method: "post",
    data: data
  });
} // 演艺票务提交审核

export function ticketSendToCheck(data) {
  return request({
    url: "/whg-park/api/activeManage/ticketSendToCheck",
    method: "post",
    data: data
  });
}
export function fetchList(data) {
  return request({
    url: "/whg-park/api/activeManage/list",
    method: "post",
    data: data
  });
} //
// 删除

export function fetchDelete(data) {
  return request({
    url: "/whg-park/api/activeManage/delete",
    method: "post",
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/activeManage/update",
    method: "post",
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/activeManage/get",
    method: "post",
    data: data
  });
} // 发布活动

export function fetchPublish(data) {
  return request({
    url: "/whg-park/api/activeManage/isPublish",
    method: "post",
    data: data
  });
} // 活动成果上传

export function fetchActiveUpload(data) {
  return request({
    url: "/whg-park/api/activeManage/upload",
    method: "post",
    data: data
  });
} // 活动成果查看

export function fetchActiveGet(data) {
  return request({
    url: "/whg-park/api/activeManage/getUpload",
    method: "post",
    data: data
  });
}